import React from "react";

export default function User({ user, isAnonymus, eleRef }) {
    return (
        <div className="experts-details">
            <span className="experts-photo">
                {user.ans_userpic && user.ans_userpic != '' && user.ans_userpic.toLowerCase() != "null" ?
                    <img src="https://cdn.cdnparenting.com/articles/babynameimages/loader.gif" data-src={user.ans_userpic.replace("http://", "https://")} onError={(e) => { e.target.src = 'https://cdn.fcglcdn.com/brainbees/parenting/img/m/default-img.png'}} alt="" className="loadingImg" />
                    :
                    <img src="https://cdn.cdnparenting.com/articles/babynameimages/loader.gif" data-src="https://cdn.fcglcdn.com/brainbees/parenting/img/m/default-img.png" alt="" className="loadingImg" />
                }
            </span>
            {user.ans_is_specialist &&
                <span className="experts-tag">Expert</span>
            }
            <span className="experts-name">
                {user.ans_user_name && user.ans_user_name != '' && parseInt(isAnonymus) == 0 ?
                    <span className="exp-name M14_42">{user.ans_user_name}</span>
                    :
                    <span className="exp-name M14_42">Community User</span>
                }
                {user.ans_user_description && user.ans_user_description != '' && parseInt(isAnonymus) == 0 ?
                    <span className="R13_9e experts-desc">{user.ans_user_description}</span>
                    :
                    <span className="R13_9e experts-desc"></span>
                }
            </span>
            {user.ans_posted_time && user.ans_posted_time != '' ?
                <span className="experts-last-online-time R13_9e">{user.ans_posted_time}</span>
                :
                <span className="experts-last-online-time R13_9e"></span>
            }
        </div>
    );
}


// WEBPACK FOOTER //
// src/shared/qna/common/User.js